
    <button class="esk-tool" (click)="cancel()"><span class="fa fa-times"></span></button>
    <button class="esk-tool" (click)="undo()"><span class="fa fa-undo"></span></button>
    <button class="esk-tool" [disabled]="selection.size === 0" (click)="finished()"><span class="fa fa-check"></span></button>
